import { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { toastService } from '@modules/toasts';

import { logout } from '../duck';
import { intl } from '../localization/translate';

export const authBroadcast = new BroadcastChannel('auth_channel');

export function useAuthBroadcast() {
  const dispatch = useDispatch();

  useEffect(() => {
    authBroadcast.onmessage = event => {
      const isSelf = event.source === self;
      if (isSelf) return;

      if (event.data?.type === 'logout') {
        toastService.info(
          intl.formatMessage({ id: 'shared.loggedOutFromTab' }),
        );
        dispatch(logout(undefined, { fromBroadcast: true }));
      }
    };
    return () => authBroadcast.close();
  }, [dispatch]);

  return { authBroadcast };
}
